import { render, staticRenderFns } from "./pdfconguia.vue?vue&type=template&id=32804878"
import script from "./pdfconguia.vue?vue&type=script&lang=js"
export * from "./pdfconguia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports